import ActivityIndicator from './ActivityIndicator';

export * from './AnimatedLoader';
export * from './Spinner';

export { ActivityIndicator };
export default ActivityIndicator;